import axios from './api';
import { getQueryData, getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/nonconformity';
const minioEndPoint = getUrl('api') + '/api/v2';

const parseColumnsFilters = (filters) => {
  let newSorteable = filters.sortable;
  let newFilter;
  if (filters.sortable) {
    const [filter, order] = filters.sortable.split('-');
    if (order !== 'NONE') {
      switch (filter) {
        case 'ncNumber':
          newSorteable = newSorteable.replace(filter, 'resume');
          break;
        case 'openDate':
          newSorteable = newSorteable.replace(filter, 'created');
          break;
        case 'csvFileName':
          newSorteable = newSorteable.replace(filter, 'file_name');
          break;
        default:
          break;
      }
    } else {
      newSorteable = '';
    }
  }

  if (filters.ncNumber) {
    newFilter = { resume: filters.ncNumber };
  }

  if (filters.openDate) {
    newFilter = { created: filters.openDate };
  }

  if (filters.csvFileName) {
    newFilter = { file_name: filters.csvFileName };
  }

  delete filters.ncNumber;
  delete filters.openDate;
  delete filters.csvFileName;

  return { ...filters, sortable: newSorteable, ...newFilter };
};

export const getNCs = async ({ page, size, filters }) => {
  if (filters.pid) {
    filters.project = filters.pid;
    delete filters.pid;
  }
  return axios
    .get(
      endPoint.concat(getQueryData(page, size, parseColumnsFilters(filters))),
      {},
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const getNC = async (id) => {
  return axios
    .get(endPoint.concat(`/${id}`), {})
    .then((response) => response)
    .catch((error) => error.response);
};

export const deleteNC = (id) =>
  axios
    .delete(endPoint.concat(`/${id}`))
    .then((response) => response)
    .catch((error) => error.response);

export const getCSVByProject = (id) =>
  axios
    .get(endPoint.concat(`/csv/${id}`))
    .then((response) => response)
    .catch((error) => error.response);

export const getCSV = (filename) =>
  axios
    .get(minioEndPoint.concat(`/minio/CSV/${filename}`))
    .then((response) => response)
    .catch((error) => error.response);

export const getUnusedNC = (id) =>
  axios
    .get(endPoint.concat(`?project=${id}&file_name=null`))
    .then((response) => response)
    .catch((error) => error.response);
